import { PUSH_NOTIFICATION } from '../types/admin.types'
import { AUTH_SUCCESS, LOGOUT } from '../types/admin.types'


const INITIAL_STATE = { token: window.sessionStorage.getItem('token'), user: null }


function authReducer(state = INITIAL_STATE, action) {
  const { type, payload } = action
  switch (type) {
    case AUTH_SUCCESS:
      console.log('AUTH_SUCCESS payload: ', payload);
      window.sessionStorage.setItem('token', payload.token)
      return { ...state, ...payload }
    case LOGOUT:
      window.sessionStorage.clear()
      return { ...state, token: null, user: null }
    case PUSH_NOTIFICATION:
      console.log('PUSH_NOTIFICATION payload: ', payload);
      return [...state, payload]
    default:
      return state
  }
}

export default authReducer